import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface State {
  bucket: string | undefined;

  actions: {
    selectBucket: (bucket: string | undefined) => void;
  };
}

const useState = create<State>()(
  persist(
    (set) => ({
      bucket: undefined,
      actions: {
        selectBucket: (bucket) => set({ bucket }),
      },
    }),
    {
      name: 'ace.buckets',
      storage: createJSONStorage(() => sessionStorage),
      partialize: ({ actions: _, ...state }) => state,
    },
  ),
);

export const useSelectedBucket = () => useState((state) => state.bucket);

export const useBucketsActions = () => useState((state) => state.actions);
